import { createSlice } from "@reduxjs/toolkit";

// Filtros de la planilla de terapeutas: se puede filtrar por terapeuta
// (muchos periodos) o por periodo (muchos terapeutas).
const initialState = {
    filters: {
        idTerapeuta: 0,
        idPeriodo: 0,
    },
    listTerapeutas: [{ id: 0, descripcion: "" }],
    listPeriodos: [{ id: 0, descripcion: "" }],
    results: [],
}

export const planillaSearchSlice = createSlice({
    name: "planillaSearch",
    initialState,
    reducers: {
        setValue: (state, action) => {
            const { name, value } = action.payload;

            state.filters[name] = value;
        },
        setResults: (state, action) => {
            state.results = action.payload;
        },
        setListTerapeutas: (state, action) => {
            state.listTerapeutas = action.payload;
        },
        setListPeriodos: (state, action) => {
            state.listPeriodos = action.payload;
        },
    },
});

export const { setValue, setResults, setListTerapeutas, setListPeriodos } = planillaSearchSlice.actions;
export default planillaSearchSlice.reducer;
